import React, { FC } from 'react'
import i18n from 'i18next'
import { IonButton } from '@ionic/react'
import { useHistoryNew } from '@utils'
import { Empty } from '@cps'
import { memberMobx, themeMobx } from '@mobxStore'
import { observer } from 'mobx-react'
// interface
interface IProps {
}
interface IState {
}

const OrdersNoLogin: FC<IProps> = ({ }) => {
  const history = useHistoryNew()
  const initialState: IState = {
  }
  const abnormalStateSetting = themeMobx.data?.abnormalStateSetting
  const goLogin = () => {
    history.push('/login')
  }
  return (
    <div className='order-login'>
      {/* <i className='iconfont icon-canpin'></i>
      <h4>{i18n.t('order.awaits')}</h4> */}
      <Empty
        msg={abnormalStateSetting?.[1]?.subName || ''}
        iconType='dicon'
        iconName={abnormalStateSetting[1]?.icon}
        picUrl={abnormalStateSetting[1]?.pic}
        height='55vh'
      />
      <p>{i18n.t('order.loginhas')}</p>
      <IonButton className='order-button' onClick={goLogin}>{i18n.t('order.gologin')}</IonButton>
    </div>
  )
}

export default observer(OrdersNoLogin)
